import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { DocumentProfileSurveyService } from '../../service/document-profile-survey/document-profile-survey.service';
import { DocumentProfileSurvey } from '../../class/document-profile-survey';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { Candidate } from '../../class/candidate';
import { CandidateService } from '../../service/candidate/candidate.service';
import { config } from '../../../../../environments/config';
import { UploadFilesService } from '../../service/upload-files/upload-files.service';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { values } from 'lodash';

@Component({
  selector: 'app-document-profile-surveys',
  templateUrl: './document-profile-surveys.component.html',
  styleUrls: ['./document-profile-surveys.component.scss']
})
export class DocumentProfileSurveysComponent implements OnInit {

    @Input() profile_survey_id: number;
    @Input() citation_id: number;
    @Input() edit: DocumentProfileSurvey;
    public promiseForm: Promise<any>;
    public form: FormGroup;

    public msgs: Message[] = [];
    public documentProfileSurveys: DocumentProfileSurvey[];
    public selectDocumentProfileSurvey: DocumentProfileSurvey;
    public selectDocumentProfileSurveyType: string;
    public documentProfileSurveyID: number = 0;
    public modNew = false;
    public modView = false;
    public openDocumentProfileSurvey = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public selectCandidate: Candidate;
    public modViewDialogCandidate: boolean;
    public candidate: Candidate[];
    public sticky: boolean;

    public form3: FormGroup;
    public candidate_id_filter: AbstractControl;
    public company_id_filter: AbstractControl;
    public first = 0;
    public filters: any[];

    public sortActivated: boolean;
    public sortRetired: boolean;

    public modViewDialogDocumentation: boolean;
    public modViewDialogTypeRetirement: boolean;
    public save_exit: boolean;

    public apiUrl = config.API_ROOT;

    public uploadedAttachment: any[] = [];
    public prewiewFileAttachment: any;
    public promiseAttachment: Promise<any>;
    public type_retirement: AbstractControl;
    public optionsTypeRetirement: any[];


    constructor(
        public documentProfileSurveyService: DocumentProfileSurveyService,
        public confirmationService: ConfirmationService,
        public candidateService: CandidateService,
        private notificationsService: NotificationsService,
        public uploadFilesService: UploadFilesService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,

        fb: FormBuilder) {

            this.form = fb.group({
            });

            this.form3 = fb.group({
                'candidate_id_filter': [''],
                'company_id_filter': [''],
            });
            this.candidate_id_filter = this.form3.controls['candidate_id_filter'];
            this.company_id_filter = this.form3.controls['company_id_filter'];

            this.modViewDialogCandidate = false;
            this.modViewDialogDocumentation = false;
            this.modViewDialogTypeRetirement = false;
            this.save_exit = false;
            this.sticky = false;

            this.optionsTypeRetirement = [];
            this.optionsTypeRetirement.push({label: 'Terminación Obra', value: 'Terminación Obra'});
            this.optionsTypeRetirement.push({label: 'terminación Mutuo Acuerdo', value: 'terminación Mutuo Acuerdo'});
            this.optionsTypeRetirement.push({label: 'Renuncia', value: 'Renuncia'});
        }

    ngOnInit() {
        // this.filter();
        this.page = 1;
        this.per_page = 10;
        if (this.edit) {
            if (this.edit.attachment) {
                this.uploadedAttachment = [];
                this.uploadedAttachment.push({'name': 'Doc Adjunto'});
            }
        }
    }

    public loadDocumentProfileSurveysLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';
        this.getDocumentProfileSurveys(event.globalFilter);
    }

    public getDocumentProfileSurveys(query?: string) {
        this.documentProfileSurveyService.getDocumentProfileSurvey(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
            response => {
                this.documentProfileSurveys = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    getCandidate(query?: string) {
      this.candidateService.getCandidate(this.page, this.per_page, undefined, query).toPromise().then(
          response => {
              this.candidate = response.json().data;
              if (response.json().meta.total > response.json().meta.total_filtered) {
                  this.totalRecords = response.json().meta.total_filtered;
              } else {
                  this.totalRecords = response.json().meta.total;
              }
          },
          error => {
              this.msgs = [];
              this.msgs.push( { severity: 'error', summary: 'error' } );
          }
      );
  }

  public newDocumentProfileSurvey() {
      this.modNew = !this.modNew;
      this.selectDocumentProfileSurvey = null;
      this.selectDocumentProfileSurveyType = null;
  }

  public savedDocumentProfileSurvey(res) {
      this.msgs = [];
      this.msgs.push(res);
      this.selectDocumentProfileSurvey = null;
      this.selectDocumentProfileSurveyType = null;
      this.modNew = false;
    //   this.getDocumentProfileSurveys();
  }

  public cancelDocumentProfileSurvey (res) {
      this.selectDocumentProfileSurvey = null;
      this.selectDocumentProfileSurveyType = null;
      this.modNew = false;
      this.modView = false;
    //   this.getDocumentProfileSurveys();
  }

//   public edit(documentProfileSurvey: DocumentProfileSurvey) {
//       this.modNew = true;
//       this.selectDocumentProfileSurvey = documentProfileSurvey;
//       this.getDocumentProfileSurveys();
//   }

  public view(documentProfileSurvey: DocumentProfileSurvey) {
      this.openDocumentProfileSurvey = true;
      this.selectDocumentProfileSurvey = documentProfileSurvey;
      this.documentProfileSurveyID = documentProfileSurvey.id;
      this.modView = true;
  }

  public deleteDialog(documentProfileSurvey: DocumentProfileSurvey) {
      let message;
      this.translate.get('Do you want to delete?').subscribe((res: string) => {
          message = res;
      });

      let header;
      this.translate.get('Delete Confirmation').subscribe((res: string) => {
          header = res;
      });

      this.confirmationService.confirm({
          message: message,
          header: header,
          icon: 'fa fa-trash',
          accept: () => {
              this.delete(documentProfileSurvey);
          }
      });
  }

  public delete(documentProfileSurvey: DocumentProfileSurvey) {
      this.documentProfileSurveyService.deleteDocumentProfileSurvey(documentProfileSurvey.id).toPromise().then(
          response => {
              this.msgs = [];
              this.msgs.push( { severity: 'success', summary: 'deleted' } );
              this.getDocumentProfileSurveys();
          },
          error => {
              this.msgs = [];
              this.msgs.push( { severity: 'error', summary: 'error' } );
          }
      );
  }

  public filter (values?, pageRefresh?) {
    if (pageRefresh) {
        this.page = 1;
        this.first = 0;
        this.per_page = 100;
    }
    this.filters = [];
    if (this.profile_survey_id) {
        this.filters.push({'key': 'profile_survey_id-in', 'value': this.profile_survey_id});
    }
    this.getDocumentProfileSurveys();
  }

  public filterAllDocumentProfileSurveyList() {
    this.selectDocumentProfileSurveyType = undefined;
  }

  public filterDocumentProfileSurveyList() {
    this.selectDocumentProfileSurveyType = 'Contrato';
  }

  public filterRetireDocumentProfileSurveyList() {
    this.selectDocumentProfileSurveyType = 'Retiro';
  }

  public filterAll() {
    this.sortActivated = false;
    this.sortRetired = false;
    this.page = 1;
    this.first = 0;
    this.filter(true);
  }

  public filterActivated() {
      this.sortActivated = true;
      this.sortRetired = false;
      this.page = 1;
      this.first = 0;
      this.filter(true);
  }

  public filterRetired() {
      this.sortActivated = false;
      this.sortRetired = true;
      this.page = 1;
      this.first = 0;
      this.filter(true);
  }

  public viewDialogCandidate(candidate: Candidate, sticky: boolean) {
    this.selectCandidate = candidate;
    this.modViewDialogCandidate = true;
    this.sticky = sticky;
  }

  public viewHideDialogCandidate() {
    if (!this.sticky) {
        this.modViewDialogCandidate = false;
    }
  }

  public cancelCandidate (res) {
      this.selectCandidate = null;
      this.modViewDialogCandidate = false;
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

//   public formatDate(date) {
//     const d = new Date(date);
//     let month = '' + (d.getMonth() + 1);
//     let day = '' + d.getDate();
//     const year = d.getFullYear();
//     let hours = '' + d.getHours();
//     let minutes = '' + d.getMinutes();
//     let seconds = '' + d.getSeconds();

//     if (month.length < 2) {
//         month = '0' + month;
//     }
//     if (day.length < 2) {
//         day = '0' + day;
//     }

//     if (hours.length < 2) {
//         hours = '0' + hours;
//     }

//     if (minutes.length < 2) {
//         minutes = '0' + minutes;
//     }

//     if (seconds.length < 2) {
//         seconds = '0' + seconds;
//     }

//     return [year, month, day].join('-') + ' ' + [hours, minutes, seconds].join(':');
// }


    public onUploadFileDocumentProfileSurvey(event: any) {
        console.log(event);
    }

    public updateAttachmentDocumentProfileSurvey(event, checklist_profile_survey) {
        let id;
        if (checklist_profile_survey.document_profile_survey.length > 0) {
            id = checklist_profile_survey.document_profile_survey[0].id;
        }

        this.uploadedAttachment = [];
        for (const file of event.files) {
            this.uploadedAttachment.push(file);
        }

        this.promiseAttachment = this.uploadFilesService.updateAttachmentDocumentProfileSurvey(this.uploadedAttachment, id, this.citation_id, this.profile_survey_id, checklist_profile_survey.id, checklist_profile_survey.list_doc_profile_survey_id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.notificationsService.growlNotify('success', res);
                });
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                    });
                });
            }
        );
    }

    public deleteAttachmentDocumentProfileSurvey(id) {
        this.promiseAttachment = this.uploadFilesService.deleteAttachmentDocumentProfileSurvey(id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.notificationsService.growlNotify('success', res);
                });
                delete this.uploadedAttachment[id];
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                    });
                });
            }
        );
    }

    public gotoAttachmentDocumentProfileSurvey(id) {
        window.open(this.apiUrl + '/document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
    }

    public gotoAttachment(id) {
        window.open(this.apiUrl + '/list-document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/document-profile-surveys/document-profile-surveys.component.ts